import { smartPluralize } from "@memorang/helpers/common";
import { useTranslation } from "react-i18next";
import { Dialog, Text } from "react-native-paper";
import { useAppTheme } from "../../useAppTheme";
import Button from "../Button";
import DialogWrapper from "../DialogWrapper";

type Props = {
	visible: boolean;
	onDismiss: () => void;
	handleAction: (type: "positive" | "negative") => void;
	hasAnsweredAtLeastOneItem?: boolean;
	isDiagnostic?: boolean;
	numItemsLeft?: number;
};

const SessionEndDialog = ({
	visible,
	onDismiss,
	handleAction,
	hasAnsweredAtLeastOneItem,
	isDiagnostic,
	numItemsLeft,
}: Props) => {
	const theme = useAppTheme();
	const { t } = useTranslation();

	const subtitle = hasAnsweredAtLeastOneItem
		? t(
				isDiagnostic
					? "session.endDialog.confirmEndDiagnostic"
					: "session.endDialog.confirmEnd",
				{
					num: numItemsLeft,
					itemLabel: t(smartPluralize("item", numItemsLeft!)),
				},
			)
		: t("session.endDialog.confirmEndNoAnswer");

	return (
		<DialogWrapper visible={visible} handleClose={onDismiss} width={350}>
			<Dialog.Title>{t("session.endDialog.title")}</Dialog.Title>
			<Dialog.Content>
				<Text variant="bodyMedium">{subtitle}</Text>
			</Dialog.Content>
			<Dialog.Actions>
				<Button
					textColor={theme.colors.onSurfaceVariant}
					onPress={() => {
						handleAction("positive");
					}}
				>
					{t("session.endDialog.confirmEndNoAnswerNegative")}
				</Button>
				<Button
					textColor={theme.colors.primary}
					onPress={() => {
						handleAction("negative");
					}}
				>
					{t("session.endDialog.confirmEndNoAnswerPositive")}
				</Button>
			</Dialog.Actions>
		</DialogWrapper>
	);
};

export default SessionEndDialog;
